<template>
  <div>
    <div class="heading pb-2.5 text-lg lg:text-2xl">
      {{ $t('Direct contact') }}
    </div>
    <NuxtLink
      class="lg:link-nav block whitespace-nowrap py-0 font-normal no-underline"
      rel="noopener noreferrer nofollow"
      :to="`mailto:${settings.email}`"
    >
      <IconsActionsEmail class="mr-1.5 inline h-3 lg:mr-2.5 lg:h-4" /> {{ settings.email }}
    </NuxtLink>
    <NuxtLink
      class="lg:link-nav block whitespace-nowrap py-0 font-normal no-underline lg:pb-2.5"
      rel="noopener noreferrer nofollow"
      :to="`tel:${settings.phone}`"
    >
      <IconsActionsPhone class="mr-1.5 inline h-4 lg:mr-2.5 lg:h-5" /> {{ settings.phone }}
    </NuxtLink>
    <div v-if="settings.address">
      <div
        v-if="settings.address"
        class="heading pb-2.5 pt-5 text-lg lg:pt-10 lg:text-2xl"
      >
        {{ $t('Visiting address') }}
      </div>
      <NuxtLink
        class="font-normal text-black max-lg:text-base lg:decoration-transparent lg:hover:decoration-black"
        target="_blank"
        rel="noopener noreferrer nofollow"
        :to="`${MAP_URL}GroentenFruit+Huis+B.V.`"
      >
        {{ settings.address }}<br>{{ settings.postalcode }} {{ settings.city }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const {settings} = useSofieSettings();

const MAP_URL = 'https://www.google.com/maps/dir/?api=1&destination=';
</script>
